import { Col, Form, Input, Label, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import { Btn } from "../../../AbstractElements";
import { Cancel, CreateTag, Save, TagColor, TagName } from "../../../Constant";
import { useAppDispatch, useAppSelector } from "../../../Redux-Toolkit/Hooks";
import { setTagModal } from "../../../Redux-Toolkit/Reducers/BookmarkTabSlice";

const ModalTag = () => {
  const { tagModal } = useAppSelector((state) => state.bookmarkTab);
  const dispatch = useAppDispatch();
  const tagToggle = () => dispatch(setTagModal());

  return (
    <Modal fade className="modal-bookmark" size="lg" isOpen={tagModal} toggle={tagToggle}>
      <ModalHeader className="modal-title" toggle={tagToggle}>{CreateTag}</ModalHeader>
      <ModalBody>
        <Form className="form-bookmark needs-validation">
          <Row>
            <Col md="12" className="mb-3 mt-0">
              <Label check>{TagName}</Label>
              <Input type="text" />
            </Col>
            <Col md="12" className="mb-3 mt-0">
              <Label check>{TagColor}</Label>
              <Input type="color" className="d-block" defaultValue="#33BFBF" />
            </Col>
          </Row>
          <Btn color="secondary" className="me-1" onClick={tagToggle}>{Save}</Btn>
          <Btn color="primary" onClick={tagToggle}>{Cancel}</Btn>
        </Form>
      </ModalBody>
    </Modal>
  );
};
export default ModalTag;
